import { render, staticRenderFns } from "./EditDescriptionDialog.vue?vue&type=template&id=1359e72c"
import script from "./EditDescriptionDialog.vue?vue&type=script&lang=js"
export * from "./EditDescriptionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports